/* collection-tab.js */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.coll_tab_main').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('.coll_tab_cont_tab_item'));
    const panels = Array.from(root.querySelectorAll('.coll_tab_pannle'));

    if (!tabs.length || !panels.length) return;

    function activate(i) {
      tabs.forEach((t, idx) => {
        t.classList.toggle('active', idx === i);
      });
      panels.forEach((p, idx) => {
        const isOn = idx === i;
        p.classList.toggle('is-active', isOn);
        if (isOn) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', 'hidden');
        }
      });
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate(i);
        }
      });
    });

    activate(0);
  });
});
